import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';

export type MenuManagementBrandMenuSearchParams = {
  associate_brand_id: string;
};

export type SearchBrandMenuResponse = {
  id: string;
  title: Title;
};

export const useMenuManagementBrandMenuSearch = async (
  params: MenuManagementBrandMenuSearchParams
): Promise<SearchBrandMenuResponse[]> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );
  try {
    return await menuManagementBrandMenuService.search(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
